import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Typography,
} from '@mui/material';

import { BackButton } from '../../common/BackButton';
import { clearCreateActivityDraft } from '../../../utils/activityDraftStorage';
import ActivityGroupEditor from './ActivityGroupEditor';

export default function CreateActivityPage() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    if (!id) {
        throw new Error('Company ID is required');
    }

    const companyId = parseInt(id);
    const activitiesPath = `/companies/${companyId}/activities`;

    return (
        <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
            <BackButton
                label="Назад"
                onClick={() => {
                    clearCreateActivityDraft(companyId);
                    navigate(activitiesPath);
                }}
            />

            <Typography variant="h4" component="h1" gutterBottom>
                Додати активність
            </Typography>

            <ActivityGroupEditor
                companyId={companyId}
                onSuccess={() => navigate(activitiesPath)}
                onCancel={() => {
                    clearCreateActivityDraft(companyId);
                    navigate(activitiesPath);
                }}
            />
        </Box>
    );
}
